export const FORBIDDEN_CONSTANTS = {
  id: '403',
  title: 'Forbidden',
  noSession: 'Tu sesión ha caducado!',
  goTo: 'Vuelve a iniciar sesión',
  link: 'aquí'
};
